import { FC, useCallback } from "react";
import { UnderlineExtension } from "@remirror/extension-underline";
import { useActive, useCommands } from "@remirror/react";
import { CommandButton, CommandButtonProps } from "@remirror/react-ui";

export interface ToggleUnderlineButtonProps
  extends Omit<
    CommandButtonProps,
    "commandName" | "active" | "enabled" | "attrs" | "onSelect"
  > {
  onBlur: () => void;
}

export const ToggleUnderlineButton: FC<ToggleUnderlineButtonProps> = (
  props,
) => {
  const { toggleUnderline } = useCommands<UnderlineExtension>();

  const handleSelect = useCallback(() => {
    if (toggleUnderline.enabled()) {
      toggleUnderline();
      props.onBlur();
    }
  }, [props, toggleUnderline]);

  const active = useActive<UnderlineExtension>().underline();
  const enabled = toggleUnderline.enabled();

  return (
    <CommandButton
      {...props}
      commandName="toggleUnderline"
      active={active}
      enabled={enabled}
      onSelect={handleSelect}
    />
  );
};
